import script from "./EffectButton.vue?vue&type=script&setup=true&lang=js"
export * from "./EffectButton.vue?vue&type=script&setup=true&lang=js"

import "./EffectButton.vue?vue&type=style&index=0&id=42480d1a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42480d1a"]])

export default __exports__